import axios from 'axios';
import { privateApi } from '@services/api';
import { HTTP_UNAUTHORIZED, HTTP_FORBIDDEN } from '@constants/httpStatus';
import { EndorsementPayload } from '@company/types/endorsement.type';

export default async function getCompany() {
  try {
    const response = await privateApi.request({
      method: 'GET',
      url: '/company/current',
      withCredentials: true,
    });
    return response.data;
  } catch (error: any) {
    if (error?.status === HTTP_UNAUTHORIZED) {
      return {
        loggedIn: false,
      };
    }
    // Company not validated - return specific status
    if (
      error?.status === HTTP_FORBIDDEN ||
      error?.response?.status === HTTP_FORBIDDEN
    ) {
      return {
        isValidated: false,
      };
    }
    if (error?.response?.data) {
      return error.response.data;
    }
    // let caller handle
    throw error;
  }
}

export async function searchCommonBrands(query: string) {
  const url = 'companies/suggested-brands';
  try {
    const response = await privateApi.get(url, {
      params: { filterName: query },
    });
    return response.data;
  } catch (error: unknown) {
    const errorMessage = axios.isAxiosError(error)
      ? error.response?.data?.message || error.message
      : 'Error searching brands';
    throw new Error(errorMessage);
  }
}

export async function saveEndorsement(data: EndorsementPayload) {
  const url = 'company/endorsements';
  try {
    const response = await privateApi.post(url, data);
    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message ||
          error.response?.data?.errorMessage ||
          'Error saving endorsement'
      );
    }
    throw error;
  }
}
